/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-25 13:50:27
 * @LastEditTime: 2020-11-30 10:10:51
 * @FilePath: \ensurance-front\src\store\modules\tables.js
 */
import store from 'store'
const state = {
  tableInfo: store.get('setTableInfo') || []
}
const mutations = {
  // 设置tableInfo
  setTableInfo(state, payload) {
    state.tableInfo = payload.tableInfo
  }


}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tables.js